module.exports = __webpack_public_path__ + "static/media/Chocolate.6e0db537.jpg";